import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class LogoutClickApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.LogoutClick;

  getPayload(): any {
    return {
      date: Date.now()
    };
  }

}
